/**
 * User: WangMeng
 * Date: 2018-07-18
 * Time: 9:25
 * Desc: 表格搜索公用类，提供一些表格搜索公用方法
 */

import React, { PureComponent } from 'react';
import { Table } from 'antd';
import {paramFilter, addDataIndex, afterDelPage} from '../../../utils/util';
import Pagination from '../pagination/Pagination';

export default class TableSearch extends PureComponent {
    constructor(props) {
        super(props);
        this.server = '';
        this.state = {
            searchParams: {},
            pageNum: 1,
            pageSize: 10,
            total: 0,
            data: [],
            loading: false
        };
    }

    // 搜索重置参数
    onSearch = (searchParams) => {
        this.setState({
            searchParams,
            pageNum: 1,
            total: 0
        }, () => {
            this.getData();
        });
    };

    // 分页
    pageChange = (pageNum, pageSize) => {
        this.setState({
            pageNum,
            pageSize
        }, () => {
            this.getData();
        });
    };

    // 获取搜索参数
    getParam = () => {
        const { pageNum, pageSize, searchParams } = this.state;
        return paramFilter({ pageNum, pageSize, ...searchParams });
    };

    beforeGetData = () => {
        this.setState({
            loading: true
        });
    };

    // 获取数据
    getData = () => {
        const { pageNum, pageSize } = this.state;
        let server = this.server;
        if(server) {
            this.beforeGetData();

            server(this.getParam()).then(data => {
                data = data || {};
                this.setState({
                    loading: false,
                    data: addDataIndex(data.list, pageNum, pageSize),
                    total: data.total || 0
                });
            }).catch(() => {
                this.setState({
                    loading: false,
                    data: []
                });
            });
        }
    };

    delRefresh = (delNum = 1) => {
        let { data, pageNum } = this.state;
        this.setState({
            pageNum: afterDelPage(data, pageNum, delNum)
        }, () => {
            this.getData();
        });
    };

    // modal操作
    showModal = (activeItem) => {
        this.setState({ visible: true, activeItem, modalKey: +new Date() });
    };

    hideModal = () => {
        this.setState({ visible: false });
    };

    // 获取table列
    getColumns = () => {
        return [];
    };

    render() {
        const { data, total, pageNum, pageSize, loading } = this.state;

        return (
            <Table
                rowKey="id"
                loading={loading}
                pagination={false}
                columns={this.getColumns()}
                dataSource={data}
                bordered
                footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/tableSearch/TableSearch.jsx